// Shared table types, sort helpers, and column/heading constants for the
// editor dashboard's agents table. No JSX here — keeps the manifest scanner
// (components/**/*.tsx) from treating this as a component module.
import tableRows from "@hero-app/data/editor-dashboard-table.json";

export type TableRow = (typeof tableRows)[number];
export type SortDirection = "asc" | "desc";

export type TableSortState = {
  columnId: string;
  direction: SortDirection;
};

export type TableColumn = {
  id: "name" | "lastRun" | "actions" | "credits";
  label: string;
  align: "left" | "right";
  sortKey?: keyof TableRow;
  variant?: "credits";
};

export function tableSortValue(row: TableRow, column: TableColumn): string | number {
  const key = (column.sortKey ?? column.id) as keyof TableRow;
  const value = row[key];
  if (typeof value === "number") return value;
  if (typeof value === "string") return value.toLowerCase();
  return "";
}

export function compareTableRows(
  a: TableRow,
  b: TableRow,
  column: TableColumn,
  direction: SortDirection,
) {
  const left = tableSortValue(a, column);
  const right = tableSortValue(b, column);
  let cmp = 0;
  if (typeof left === "number" && typeof right === "number") {
    cmp = left - right;
  } else {
    cmp = String(left).localeCompare(String(right));
  }
  return direction === "asc" ? cmp : -cmp;
}

export const TABLE_TITLE = "Play around with the elements";
export const TABLE_SUBTITLE = "Drag, drop and interact with the dashboard components ";

export const TABLE_COLUMNS: readonly TableColumn[] = [
  { id: "name", label: "Agent name", align: "left" },
  { id: "lastRun", label: "Last run", align: "right", sortKey: "lastRunSort" },
  { id: "actions", label: "Actions used", align: "left" },
  { id: "credits", label: "Credits used", align: "left", variant: "credits" },
];
